<div class="inner-content flex flex-col">
    <div class="flex-align-center m-4 !flex justify-center">
        <h2
            class="orb-app-light-dark:font-bold var-app-light-dark:font-bold text-base font-semibold dark:text-contrast-yellow">
            {{ 'TERMS_CONDITIONS_TITLE' | translate }}
        </h2>
    </div>
    <div
        class="terms-content m-0 !flex !h-auto flex-grow p-0"
        [ngClass]="{ 'with-agree-button': !data.withAgreeButton }">
        <ng-container>
            <iframe
                class="tnc__iframe"
                [src]="data.termsUrl | safeResourceUrl"
                cdkFocusInitial
                title="{{ 'TERMS_CONDITIONS_TITLE' | translate }}">
            </iframe>
        </ng-container>
    </div>
    <div class="border-ironside_grey-100 !flex border-t border-solid dark:border-contrast-yellow"></div>
    <div class="relative !flex flex-col overflow-y-auto px-4 pt-0">
        <ng-container>
            <button
                class="align-center orb-app-light-dark:font-semibold vl-app-light:text-primary var-app-light:text-primary var-app-light-dark:font-normal h-12 rounded-lg bg-white pt-2 text-base font-bold text-secondary dark:bg-transparent dark:text-contrast-yellow"
                (click)="agreeTerms(false)">
                {{ 'CLOSE' | translate }}
            </button>

            <button
                class="orb-app-light-dark:text-black orb-app-light-dark:font-semibold vl-app-light:text-black var-app-light:text-black var-app-light-dark:font-normal mb-4 h-12 rounded-lg bg-[var(--btn-primary-color)] text-base font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                *ngIf="data.withAgreeButton"
                (click)="agreeTerms(true)">
                {{ 'AGREE_WITH_TERMS_AND_CONDITIONS' | translate }}
            </button>
        </ng-container>
    </div>
</div>
